export default __webpack_public_path__ + "static/media/MAINT.9e27f416.jpg";